var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('home-carousel'),_c('about-us'),_c('service-card'),_c('call-us')],1)}
var staticRenderFns = []

export { render, staticRenderFns }